import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "caret--sprite",
  "use": "caret--sprite-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"caret--sprite\">\n<g>\n<path d=\"M5.20711 7C4.76165 7 4.53857 7.53857 4.85355 7.85355L7.64645 10.6464C7.84171 10.8417 8.15829 10.8417 8.35355 10.6464L11.1464 7.85355C11.4614 7.53857 11.2383 7 10.7929 7L5.20711 7Z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol